// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueResource from 'vue-resource'
import VueCookies from 'vue-cookies'
import App from '@/App'
import router from '@/router'
import store from '@/store'
import BootstrapVue from 'bootstrap-vue'
import appConfig from '@/config.js'
import InputFacade from 'vue-input-facade'

// Gettext i18n
import GetTextPlugin from 'vue-gettext'
import translations from './translations.json' // All the app (l10n, ie.: es_AR, es_PE, etc.)
import translationsAuth from './translations-auth.json'

// Local Filters
import * as dataFilters from './common/dataFilters'

// Entity Prefix Sanitization Filter
import cleanentityprefix from '@/common/dataFilters/cleanEntityPrefix'

// Mixins
import TitleMixin from '@/mixins/title.mixin'

import UtilsMixin from '@/mixins/utils.mixin'

import FetchesMixin from '@/mixins/fetches.mixin'

// import ModelsMixin from '@/common/models'
// Vue.use(ModelsMixin)

// Override default Leaflet package icons to avoid console errors
import { Icon } from 'leaflet'

// Font Awesome Icons
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserPlus, faUsersCog, faUser, faUserCog, faSignOutAlt, faBookmark, faTrashAlt, faPhone, faCheck, faArrowAltCircleLeft, faEdit, faPencilAlt, faMapMarker, faMapMarkerAlt, faMapMarkedAlt, faBolt, faExclamationTriangle, faDownload, faFilePdf, faSyncAlt, faLifeRing, faStore, faPlus, faPen, faCog, faCircle, faQuestionCircle, faPrint, faChevronLeft, faChevronRight, faShippingFast, faComment, faExternalLinkAlt, faKeyboard, faPaperclip, faCrosshairs, faEnvelope, faHome, faList, faExchangeAlt, faStar, faCloudRain, faTrailer, faBullseye, faFilter, faEllipsisV, faPlusCircle, faLink, faUnlink, faSearch, faDrawPolygon, faArrowsAltV, faBan, faHistory, faClipboardList, faToggleOn, faToggleOff, faGlobeAmericas, faTable, faGripHorizontal, faDirections, faTruckMoving } from '@fortawesome/free-solid-svg-icons'
import { faBookmark as farBookmark, faClock, faCopy, faCalendarAlt, faImage, faEye, faEyeSlash, faCheckCircle, faTimesCircle } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'

// MomentJS
import * as moment from 'moment-timezone'
import momentDurationFormatSetup from 'moment-duration-format'

// Layouts
import DefaultLayout from '@/components/Layout/Default'
import AuthLayout from '@/components/Layout/Auth'
import FullMapLayout from '@/components/Layout/FullMap'
import PageTitle from '@/components/Layout/PageTitle/PageTitle'

// Shared components
import UserCard from '@/components/Users/Card'
import CompanyCard from '@/components/CompanyCard'
import ShippingCheckpoint from '@/components/Shippings/Checkpoint'
import ShippingItems from '@/components/Shippings/Items'

// HTML2Paper
import VueHtmlToPaper from 'vue-html-to-paper'

const inputFacadeOptions = {
  // use these tokens instead of the default
  tokens: {
    '#': { pattern: /\d/ },
    X: { pattern: /[0-9a-zñ]/i, transform: (v) => v.toLocaleUpperCase() },
    x: { pattern: /[0-9a-zñ]/i, transform: (v) => v.toLocaleLowerCase() },
    S: { pattern: /[a-zñ]/i },
    A: { pattern: /[a-zñ]/i, transform: (v) => v.toLocaleUpperCase() },
    a: { pattern: /[a-zñ]/i, transform: (v) => v.toLocaleLowerCase() },
    '\\': { escape: true },
    '?': { optional: true },
    '*': { repeat: true },
    '|': { pipe: true }
  }
}
Vue.use(InputFacade, inputFacadeOptions) // Just Auth related pages (i18n only, ie.: es)
console.log(navigator.languages)

translations = { ...translations, ...translationsAuth }

console.log(translations)

Vue.use(VueResource)
Vue.use(VueCookies, { path: '/' })
Vue.use(BootstrapVue, {
  BTooltip: {
    boundary: 'viewport'
  }
})
Vue.prototype.$appConfig = appConfig

// Roles
Vue.prototype.$roles = window.roles = {
  COURIER: 'courier',
  COMPANY_ADMIN: 'company-admin',
  GCM_ADMIN: 'gcm-admin',
  GCMR_ADMIN: 'gcmr-admin',
  SUPER_ADMIN: 'super-admin',
  OPERATOR: 'operator',
  OPERATOR_SUPERVISOR: 'operator-supervisor',
  HEAD_SALES: 'head-sales',
  COMMERCIAL: 'commercial',
  ACCOUNTANT: 'accountant',
  INTERNATIONAL: 'international'
}
for (const key of Object.keys(dataFilters)) {
  Vue.filter(key.toLowerCase(), dataFilters[key])
}
Vue.filter('cleanentityprefix', cleanentityprefix)

// Global functional component for visual-only prefix sanitization in templates
Vue.component('clean-text', {
  functional: true,
  props: ['value'],
  render: (h, ctx) => h('span', ctx.data, [Vue.filter('cleanentityprefix')(ctx.props.value)])
})
Vue.mixin(TitleMixin)
Vue.mixin(UtilsMixin)
Vue.mixin(FetchesMixin)
delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

library.add(faUserPlus, faUsersCog, faUser, faUserCog, faSignOutAlt, faBookmark, faTrashAlt, faPhone, faCheck, faArrowAltCircleLeft, faEdit, faPencilAlt, faMapMarker, faMapMarkerAlt, faMapMarkedAlt, faBolt, faExclamationTriangle, faDownload, faFilePdf, faSyncAlt, faLifeRing, faStore, faPlus, faPen, faCog, faCircle, faQuestionCircle, faPrint, faChevronLeft, faChevronRight, faShippingFast, faComment, faExternalLinkAlt, faKeyboard, faPaperclip, faCrosshairs, faEnvelope, faHome, faList, faExchangeAlt, faStar, faCloudRain, faTrailer, faBullseye, faFilter, faEllipsisV, faPlusCircle, faLink, faUnlink, faSearch, faDrawPolygon, faArrowsAltV, faBan, faHistory, faClipboardList, faToggleOn, faToggleOff, faGlobeAmericas, faTable, faGripHorizontal, faDirections, faTruckMoving, farBookmark, faClock, faCopy, faCalendarAlt, faImage, faEye, faEyeSlash, faCheckCircle, faTimesCircle)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)
Vue.prototype.moment = moment
window.moment = moment
momentDurationFormatSetup(moment)
Vue.component('default-layout', DefaultLayout)
Vue.component('auth-layout', AuthLayout)
Vue.component('full-map-layout', FullMapLayout)
Vue.component('page-title', PageTitle)
Vue.component('user-card', UserCard)
Vue.component('company-card', CompanyCard)
Vue.component('shipping-checkpoint', ShippingCheckpoint)
Vue.component('shipping-items', ShippingItems)

// Plugins components
require('@/plugins')
const htmlToPaperOptions = {
  name: '_blank',
  specs: [
    'fullscreen=no',
    'titlebar=no',
    'scrollbars=no',
    'menubar=no',
    'location=no'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css'
  ]
}

Vue.use(VueHtmlToPaper, htmlToPaperOptions)

// Requests interceptors
Vue.http.interceptors.push((req, next) => {
  next(res => {
    if (req.skipErrorAlert) {
      return
    }
    let obj = {}
    if (res.status >= 402 && res.status <= 500) {
      let message = ''
      if (res.status === 422 && res.body.errors) {
        for (const error of res.body.errors) {
          message += '- ' + error.detail + '<br>'
        }
      } else {
        message = res.body.message
      }
      obj = {
        title: moovaGcm2.$gettext('ERROR'),
        message,
        type: 'error'
      }
    } else if (res.status === 0 && res.url.includes('files')) {
      obj = {
        title: moovaGcm2.$gettext('ERROR'),
        message: moovaGcm2.$gettext('Content too large'),
        type: 'error'
      }
    } else if (res.status === 0 && !res.url.includes('couriers-summary')) {
      obj = {
        title: moovaGcm2.$gettext('ERROR'),
        message: moovaGcm2.$gettext('Network error'),
        type: 'error'
      }
    }
    if (obj.message) {
      console.log('%cStatus ' + res.status + '\n"' + obj.message + '" on:\n' + res.url, 'padding: 5px; background: #f00; color: #cf0;font-size: 1.5em; font-weight: bold;')
      moovaGcm2.$root.$children[0].$refs.simplert.openSimplert(obj)
    }
  })
})

console.log('%c( ͡° ͜ʖ ͡°) for code, uh?', 'font-size: 1.2em; font-weight: bold;')
console.log('%cU ' + '%c♥' + '%c‿' + '%c♥ ' + '%cVue.js' + '%c?', 'font-size: 1.2em;', 'font-size: 1.2em; color: red', 'font-size: 1.2em;', 'font-size: 1.2em; color: red;', 'font-size: 1.2em; font-weight: bold;', 'font-size: 1.2em;')
console.log('%c(づ｡◕‿‿◕｡)づ ' + '%cSCSS' + '%c?', 'font-size: 1.2em;', 'font-size: 1.2em; font-weight: bold;', 'font-size: 1.2em;')
console.log('%cDone with that sad and empty (・3・) selfie life?', 'color: #999;')
console.log('%cDon\'t be ' + '%c=' + '%c^_^' + '%c=', 'font-size: 1.2em;', 'font-size: 1.2em; color: red', 'font-size: 1.2em;', 'font-size: 1.2em; color: red')
console.log('%cGet in touch at nico@moova.io! ', 'padding: 5px; background: #000; color: #cf0;font-size: 2em; font-weight: bold;')
console.log('%cWe will talk ' + '%cツ ', 'padding: 5px; background: #000; color: #0ff;font-size: 2em; font-weight: bold;', 'padding: 5px; background: #000; color: #fff;font-size: 2em; font-weight: bold;')
console.log('%c| (• ◡•)| and (❍ᴥ❍ʋ) will be ᕕ( ᐛ )ᕗ', 'font-size: 1.2em;')

// Disable console.log for production except if qs param is explicitly set
const qsParams = new URLSearchParams(window.location.search)
if (appConfig.debug !== true && !qsParams.has('debug')) {
  window.console.log = function () {}
}

Vue.config.productionTip = true

let moovaGcm2

window.allowedRoles = [
  {
    role: 'gcmr-admin',
    product: 'default'
  },
  {
    role: 'gcm-admin',
    product: 'carriers'
  },
  {
    role: 'courier',
    product: 'app'
  },
  {
    role: 'relocation',
    product: 'default'
  },
  {
    role: 'warehouse',
    product: 'app'
  },
  {
    role: 'company-admin',
    product: 'default'
  }
]

window.allowedShippingTypes = [
  'regular',
  'mercado_flex',
  'pickup',
  'return',
  'next_day',
  'trailer_relocation'
]

function getCookie(name) {
  const regex = new RegExp('(^|;) ?' + name + '=([^;]*)(;|$)')
  const v = regex.exec(document.cookie)
  return v ? v[2] : null
}

function setCountryCookies(country, phonePrefix) {
  document.cookie = 'country=' + country + ';path=/; SameSite=' + process.env.COOKIE_SAME_SITE + '; ' + process.env.COOKIE_SECURE
  window.country = country
  document.cookie = 'phonePrefix=' + phonePrefix + ';path=/; SameSite=' + process.env.COOKIE_SAME_SITE + '; ' + process.env.COOKIE_SECURE
  window.phonePrefix = phonePrefix
}

let forcedByDomainFrontConfig

// Get all active countries
async function fetchCountries() {
  const countryParams = {
    includes: [
      'notification_configs'
    ]
  }
  return await Vue.http.get(appConfig.api.baseUrl + 'countries', { params: countryParams })
    .then(response => {
      const isForcedByDomain = response.body.data.findIndex(x => x?.front_config?.ecosystem?.domain === window.location.hostname)
      forcedByDomainFrontConfig = isForcedByDomain !== -1 ? window.countries[isForcedByDomain].front_config : null
      if (forcedByDomainFrontConfig?.ecosystem?.restrictRegisterToCountry) {
        setCountryCookies(window.countries[isForcedByDomain].iso_code.toUpperCase(), Vue.prototype.$frontConfig.i18n.phonePrefix)
      }
      return response
    })
}

// Get visitor country by geo check
Vue.http.get(appConfig.geo.check, { headers: { Authorization: 'Basic ' + window.btoa(appConfig.geo.account + ':' + appConfig.geo.key) } })
  .then(response => {
    if (!getCookie('country')) {
      setCountryCookies(response.body.country.iso_code.toUpperCase(), '')
    } else {
      window.country = window.country || getCookie('country')
    }
  }).catch(e => { // On FAIL set AR as default
    setCountryCookies('AR', '54')
  }).finally(() => {
    // Get all active countries and check if the country is restricted by domain
    fetchCountries()
      .then(response => {
        // Set country list
        window.countries = response.body.data
        Vue.prototype.$countries = response.body.data

        if (!window.countries.some(x => x.iso_code === window.country)) {
          setCountryCookies(window.countries[0].iso_code, window.countries[0].front_config.i18n.phonePrefix)
        }

        // fetch availableLanguages
        const availableLanguages = window.countries.reduce((o, x) => ({ ...o, [x.front_config.i18n.lang]: x.front_config.i18n.langName }), {
          es: 'Spanish Auth Only'
        })

        // Set global frontend config
        let frontConfig = forcedByDomainFrontConfig
        if (frontConfig?.ecosystem?.restrictRegisterToCountry) {
          store.dispatch('setEcosystem', frontConfig.ecosystem)
        } else {
          frontConfig = response.body.data.some(x => x.iso_code === window.country) ? response.body.data.find(x => x.iso_code === window.country).front_config : null
          store.dispatch('setEcosystem', store.getters.ecosystem)
        }
        store.dispatch('setFrontConfig', frontConfig)
          .then(() => {
            // Set app roles (will fail if user is not authorized yet, repeat after login)
            store.dispatch('setAppRoles', {
              params: {
                sort: [{
                  key: 'name',
                  direction: 'asc'
                }]
              }
            })
          })

        // Set global TZ (fallback to UTC)
        frontConfig.i18n.tz = Vue.prototype.$tz = getCookie('bypassCountry') || !frontConfig.i18n.tz ? 'UTC' : frontConfig.i18n.tz
        console.log(navigator.languages[0].split('-')[0])
        console.log(availableLanguages)
        console.log(translations)
        // Set default GetTextPlugin
        Vue.use(GetTextPlugin, {
          translations,
          defaultLanguage: navigator.languages[0].split('-')[0] || 'en_US',
          silent: true,
          availableLanguages,
          languageVmMixin: {
            data: {
              translations
            },
            methods: {
              addTranslations(translations) {
                for (const lang of Object.keys(translations)) {
                  const data = translations[lang]
                  if (!this.translations[lang]) {
                    Vue.set(this.translations, lang, data)
                    return
                  }
                  for (const key of Object.keys(data)) {
                    const val = data[key]
                    Vue.set(this.translations[lang], key, val)
                  }
                }
              }
            }
          }
        })

        window.phoneFormattersFile = require('../node_modules/cleave.js/dist/addons/cleave-phone.i18n.js')

        /* eslint-disable no-new */
        moovaGcm2 = new Vue({
          el: '#app',
          router,
          store,
          template: '<App/>',
          components: { App }
        })
      })
  })
